module.exports = __webpack_public_path__ + "static/media/yycartoon.46dd0e84.png";